import { useState } from 'react'
import { Modal, Space, notification } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRocket, faPrint } from '@fortawesome/pro-solid-svg-icons'
import ItemSummary, { ItemSummaryFilter } from './ItemSummary'
import { ProjectType } from '../../../common/constants'
import { usePrintItemsSummaryReport } from './reportQueries'

type Props = {
  open: boolean
  onCancel: () => void
  jobId: number
  jobType: ProjectType
}

const PrintItemsSummaryModal = ({ open, onCancel, jobId, jobType }: Props) => {
  const [filter, setFilter] = useState<ItemSummaryFilter | null>(null)
  const [hasItems, setHasItems] = useState(false)
  const printMutation = usePrintItemsSummaryReport()

  const handlePrint = () => {
    if (!filter) {
      return
    }

    printMutation.mutate({ jobId, jobType, filter }, {
      onSuccess: (url) => {
        window.open(url, '_blank')
        onCancel()
      },
      onError: () => {
        notification.error({ message: 'There was an error printing the report.' })
      },
    })
  }

  return (
    <Modal
      title={<Space><FontAwesomeIcon icon={faRocket} /> Items Summary Report</Space>}
      open={open}
      onCancel={() => { if (!printMutation.isLoading) onCancel() }}
      onOk={handlePrint}
      okText="Print"
      okButtonProps={{
        disabled: !hasItems || !filter,
        loading: printMutation.isLoading,
        icon: <FontAwesomeIcon icon={faPrint} />,
      }}
      cancelText="Close"
      cancelButtonProps={{ disabled: printMutation.isLoading }}
      width={900}
      destroyOnClose
    >
      <ItemSummary onFilterChange={setFilter} onHasItems={setHasItems} />
    </Modal>
  )
}

export default PrintItemsSummaryModal
